import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Shield, Mail, Lock, Loader2 } from 'lucide-react';
import SEO from '../components/SEO';
import '../styles/Auth.css';

// Brand logo - larger version
const LOGO_URL = "https://customer-assets.emergentagent.com/job_express-checkout-9/artifacts/65fw8myi_Variant%201_Full%20Logo_Vector%20copy.png";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get redirect path from location state, or default to dashboard
  const from = location.state?.from?.pathname || '/dashboard';
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    const result = await login(email, password);
    
    setIsLoading(false);
    
    if (result.success) {
      navigate(from, { replace: true });
    } else {
      setError(result.error);
    }
  };
  
  return (
    <div className="auth-page">
      <SEO canonical="/login" noIndex={true} />
      <div className="auth-container">
        <div className="auth-header">
          <Link to="/" className="auth-logo auth-logo-large">
            <img src={LOGO_URL} alt="All Secured Logo" />
          </Link>
          <h1>Welcome Back</h1>
          <p>Sign in to access your courses</p>
        </div>
        
        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error">
              <Shield size={18} />
              <div className="error-content">
                <span>{error}</span>
                {error.toLowerCase().includes('verify') && (
                  <Link to="/resend-verification" className="resend-verification-link">
                    Resend verification email
                  </Link>
                )}
              </div>
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="email">
              <Mail size={18} />
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">
              <Lock size={18} />
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              required
              disabled={isLoading}
              minLength={8}
            />
          </div>
          
          <div className="form-group-link">
            <Link to="/forgot-password" className="forgot-password-link">
              Forgot password?
            </Link>
          </div>
          
          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 size={20} className="spinner" />
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>Don't have an account?</p>
          <Link to="/signup" className="auth-link">Create Account</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
